import { env } from '../env'

window.STRIPE_PUBLISHABLE_KEY = env.VITE_STRIPE_PUBLISHABLE_KEY

const stripeScript = document.createElement('script')
stripeScript.async = true
stripeScript.src = 'https://js.stripe.com/v3/'
document.body.append(stripeScript)
